export enum LIST_VIEW {
  TABLE = 'table',
  GRID = 'grid',
  SMALL_GRID = 'small-grid',
}
